import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  Grid,
  Snackbar,
  Alert,
} from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import apiService from '../components/ReasuableFuncations/api';
import { format, parseISO } from 'date-fns';

const ReminderPage = () => {
  const [title, setTitle] = useState('');
  const [comments, setComments] = useState('');
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const combinedDateTime = date && time 
        ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes())
        : null;

      const reminderData = { title, comments, datetime: combinedDateTime };

      const response = await apiService.post(`/api/reminder`, reminderData);

      if (response.statusText !== 'Created') {
        throw new Error('Failed to create reminder');
      }

      setTitle('');
      setComments('');
      setDate(null);
      setTime(null);

      setSnackbarOpen(true); 
    } catch (error) {
      console.error('Error saving reminder:', error);
      alert('Error saving reminder. Please try again.');
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Container maxWidth="md" sx={{ paddingRight: '40px', paddingTop: '20px' }}>
      <Paper elevation={20} sx={{ p: 4, mt: 4 }}>
        <Typography variant="h4" gutterBottom>Create Reminder</Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="Title"
                variant="outlined"
                fullWidth
                margin="normal"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Comments"
                variant="outlined"
                fullWidth
                margin="normal"
                multiline
                rows={2}
                maxRows={5}
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                required
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                type="date"
                value={date ? format(date, 'yyyy-MM-dd') : ''}
                onChange={(e) => setDate(parseISO(e.target.value))}
                min={format(new Date(), 'yyyy-MM-dd')}
                required
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  label="Select Time"
                  value={time}
                  onChange={(newTime) => setTime(newTime)}
                  renderInput={(params) => <TextField {...params} />}
                  required
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={12}>
              <Button variant="contained" color="primary" type="submit">
                Save Reminder
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          Reminder created successfully!
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default ReminderPage;
